import * as React from 'react';
import MultiSelectModal from '../../../misc/components/queryTable/MultiSelectModal';
import {
    Query,
    QueryCondition,
    QueryFilter,
    SpirometrySessionMetadata,
    User
} from "../../../misc/api/apiTypes";
import { PermissionEnum } from '../../../misc/api/ApiPermissionEnum';
import { useCurrentStudyConfigurationContext } from '../../../Core/CurrentStudyConfigurationContext';
import { useWebPortalLegacyClient } from '../../../misc/api/WebPortalTokenClient';

const OverreaderUserNameKey = "Email";
const OverreaderFilterQueryCondition = QueryCondition.Equal;
export const OverreaderHeaderText = "Overreader";

interface OverreaderFilterProps {
    permissionToGetUserFor: PermissionEnum;
    filterMember: string;
    onClose: (member: string, condition: QueryCondition, values: string[]) => void;
    query: Query<SpirometrySessionMetadata>;
}

const OverreaderFilterModal = ({ permissionToGetUserFor, filterMember, onClose, query }: OverreaderFilterProps): JSX.Element => {

    const GetQueryFilter = (query: Query<SpirometrySessionMetadata>): QueryFilter => {
        return query.Filters.find(filter => filter.Member === filterMember && filter.Condition === OverreaderFilterQueryCondition);
    }

    const queryFilter = GetQueryFilter(query) || { Values: [] };

    const [values, setValues] = React.useState<any[]>(queryFilter.Values);

    const [allOverreaders, setAllOverreaders] = React.useState<User[]>(null);

    const { study } = useCurrentStudyConfigurationContext();
    const legacyClient = useWebPortalLegacyClient();

    React.useEffect(() => {
        legacyClient.getUsersByPermission(study.id, permissionToGetUserFor).then(overreaders => {
            setAllOverreaders(overreaders);
        });
    }, []);

    return (<MultiSelectModal header={OverreaderHeaderText + ' Filter'}
        isLoading={!allOverreaders}
        show={true}
        options={allOverreaders}
        valueKey={OverreaderUserNameKey}
        labelKey={OverreaderUserNameKey}
        values={values}
        onChange={(updatedValues: string[]) => {
            setValues(updatedValues.length > 0 ? updatedValues.map(v => v[OverreaderUserNameKey]) : null);
        }}
        onClose={() => {
            onClose(filterMember, OverreaderFilterQueryCondition, values);
        }}
        onClear={() => {
            onClose(filterMember, OverreaderFilterQueryCondition, []);
        }}
    />)
}

export default OverreaderFilterModal;
